@import 'styles/mixins';

.container {
  width: 100%;

  &.opacity {
    opacity: 0.5;
  }
}
